import { Box, Stack, Typography } from "@mui/material";
import { ScoreRating } from "~/operations";
import WorkflowRiskDots from "../../WorkflowRiskDots";

export default function WorkflowAssetTableRiskScoreCell({
  value,
}: {
  value: ScoreRating;
}) {
  if (!value) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <Stack direction="column" alignItems="flex-start" gap={1}>
        <Typography
          variant="caption"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: 16,
            textTransform: "uppercase",
          }}
        >
          {value}
        </Typography>
        <WorkflowRiskDots riskRating={value} />
      </Stack>
    </Box>
  );
}
